import { CTAChevron } from "assets/helper/icons"
import { useMainOfficeNumber } from "hooks/useMainOfficeNumber"
import { useSideNav } from "hooks/useSideNav"
import React from "react"

interface PhoneLinkParser {
  className: string
  customPhoneNumber: string
  showIcon: boolean
  useMainOfficeTrackingNumber: boolean
  children?: string
}

export const PhoneLinkParser = ({
  className,
  showIcon,
  customPhoneNumber,
  useMainOfficeTrackingNumber,
  children,
}: PhoneLinkParser) => {
  const { handleCloseNav } = useSideNav()

  const { mainOfficeNumber } = useMainOfficeNumber({})

  const contactNumber = useMainOfficeTrackingNumber
    ? mainOfficeNumber
    : customPhoneNumber
  return (
    <a
      href={`tel: ${contactNumber}`}
      className={`${className} u-phone-link`}
      onClick={handleCloseNav}
    >
      {children || contactNumber}
      <CTAChevron />
    </a>
  )
}
